import React from 'react'
import { FaCodepen, FaRegUser } from 'react-icons/fa'
import { FiPenTool } from 'react-icons/fi'
import { ImFileText } from 'react-icons/im'
import { RiContactsBookLine } from 'react-icons/ri'
import { Link, useLocation } from 'react-router-dom'


const Navbar = () => {
  let location = useLocation();
  const navData = [
    {
      id:1,
      icon:<FaRegUser/>,
      title:'About',
      route:'/'
    },
    {
      id:2,
      icon: <ImFileText/>,
      title:'Resume',
      route:'/resume'
    },
    {
      id:3,
      icon:<FaCodepen/>,
      title:'Portfolio',
      route:'/portfolio'
    },
    {
      id:4,
      icon: <FiPenTool/>,
      title:'Designs',
      route:'/designs'
    },
    {
      id:5,
      icon: <RiContactsBookLine />,
      title:'Contact',
      route:'/contact'
    }
  ]
  return (
    <nav className='navbar'>
    {
        navData.map(({ id, icon, title, route }) =>{
        return(
          <Link to={route} key={id} className={`nav-item ${location.pathname === route ? 'active' : ''}`}>
            {icon}
            <span>{title}</span>
          </Link>
        )
      })
    }
    </nav>
  )
}

export default Navbar